
export const getBranding = () => {
  const hostname = window.location.hostname;

  // MyTechBuddy Branding
  const mtbBranding = {
    theme: 'my-tech-buddy',
    logo: {
      type: 'text',
      content: 'Prism',
    },
    toolName: 'Prism',
    companyName: 'MyTechBuddy',
    shortCompanyName: 'MTB',
    companyLink: 'https://my-tech-buddy.com',
    colors: {
      light: {
        primary: '#08D8E4',      // SkyDiver Blue
        secondary: '#A3D100',    // Wild Vine Green
        accent: '#F05A00',       // Sunset Blaze
        emphasis: '#004E5F',     // Twilight Sky
        text: '#212529',         // Dark Gray for text
        background: '#f0f2f5',   // Light gray background
        cardBackground: '#ffffff', // White for cards/sections
        cardBorder: '#dee2e6',   // Light gray for borders
      },
      dark: {
        primary: '#08D8E4',      // SkyDiver Blue (accent)
        secondary: '#A3D100',    // Wild Vine Green (accent)
        accent: '#F05A00',       // Sunset Blaze (buttons)
        emphasis: '#FFFFFF',     // White (headings)
        text: '#adb5bd',         // Light Gray for text
        background: '#0c1a2c',   // Very Dark Blue
        cardBackground: '#1a2a3a', // Dark Muted Blue
        cardBorder: '#3a4a5a',   // Muted Blue for borders
      }
    },
    fonts: {
      main: 'Ubuntu, sans-serif',
    }
  };

  // Citadel Strategic Ventures Branding
  const csvBranding = {
    theme: 'citadel-strategic-ventures',
    logo: {
      type: 'text',
      content: 'Prism',
    },
    toolName: 'Prism',
    companyName: 'Citadel Strategic Ventures',
    shortCompanyName: 'CSV',
    companyLink: 'https://citadelstrategicventures.com',
    colors: {
      light: {
        primary: '#0A2342',      // Citadel Blue
        secondary: '#BCC1C6',    // Summit Gray
        accent: '#DD6B20',       // Venture Orange
        emphasis: '#0A2342',     // Citadel Blue
        text: '#212529',
        background: '#f0f2f5',
        cardBackground: '#ffffff',
        cardBorder: '#dee2e6',
      },
      dark: {
        primary: '#4a90e2',       // Lighter Blue from example for links/accents
        secondary: '#BCC1C6',    // Summit Gray (can be used for text)
        accent: '#DD6B20',       // Venture Orange (buttons)
        emphasis: '#FFFFFF',     // White (headings)
        text: '#c0c0c0',         // Light Gray from example
        background: '#0c1a2c',   // Very Dark Blue from example
        cardBackground: '#1a2a3a', // Dark Muted Blue from example
        cardBorder: '#3a4a5a',   // Muted Blue for borders from example
      }
    },
    fonts: {
      main: 'Ubuntu, sans-serif',
    }
  };

  if (hostname.includes('my-tech-buddy')) {
    mtbBranding.toolName = 'BuddyTools';
    mtbBranding.logo.content = 'BuddyTools';
    return mtbBranding;
  } else if (hostname.includes('citadelstrategicventures')) {
    csvBranding.toolName = 'Armory';
    csvBranding.logo.content = 'Armory';
    return csvBranding;
  } else {
    // Default branding
    return mtbBranding;
  }
};

export const setDynamicTitle = () => {
  const branding = getBranding();
  document.title = `${branding.toolName} by ${branding.companyName}`;
};
